/**
 * Country flags for jurisdiction labels (Fan, 2026-08-30: "wherever you have
 * UK mentioned include the UK flag, wherever you have France mentioned, use
 * the France flag").
 *
 * One source of truth for the emoji and for the label->flag mapping, so a
 * chart legend, a stat-card subline, a tab and a table header all render the
 * same thing. lib/jurisdictionConfig.js keeps its own `flag` field for the
 * By Jurisdiction cards; both read the constants below.
 *
 * withFlag() is deliberately conservative: it only prefixes labels it
 * RECOGNISES as a jurisdiction (UK / United Kingdom / GB / France / FR /
 * Français variants, case-insensitive, whole label), so passing an arbitrary
 * string through it is a no-op rather than a guess.
 */

export var UK_FLAG = '\uD83C\uDDEC\uD83C\uDDE7';
export var FR_FLAG = '\uD83C\uDDEB\uD83C\uDDF7';
export var PERSONAL_ICON = '\uD83D\uDC64';

var UK_LABELS = ['uk', 'u.k.', 'gb', 'gbr', 'united kingdom', 'uk properties', 'scotland'];
var FR_LABELS = ['fr', 'france', 'fra', 'french', 'france properties'];

/** Flag emoji for a jurisdiction label, or '' when it is not one. */
export function flagFor(label) {
  if (label == null) return '';
  var key = String(label).trim().toLowerCase();
  if (UK_LABELS.indexOf(key) !== -1) return UK_FLAG;
  if (FR_LABELS.indexOf(key) !== -1) return FR_FLAG;
  return '';
}

/** 'UK' -> '🇬🇧 UK'. Unrecognised labels are returned unchanged. */
export function withFlag(label) {
  var flag = flagFor(label);
  return flag ? flag + ' ' + label : (label == null ? '' : String(label));
}

/**
 * Flag for a region key as used by the portfolio/costs pages ('uk' | 'fr'),
 * an entity country field ('UK' | 'France' | 'UK/France'), or a currency
 * ('GBP' -> UK, 'EUR' -> France). Returns '' when nothing is implied --
 * never a defaulted UK flag, which would mislabel unassigned rows.
 */
export function flagForRegion(region) {
  if (region == null) return '';
  var key = String(region).trim().toLowerCase();
  if (key === 'uk/france' || key === 'both') return UK_FLAG + FR_FLAG;
  var direct = flagFor(key);
  if (direct) return direct;
  if (key === 'gbp') return UK_FLAG;
  if (key === 'eur') return FR_FLAG;
  return '';
}
